import { render, staticRenderFns } from "./SellBusienesAssoclate.vue?vue&type=template&id=28a0d878&scoped=true&"
import script from "./SellBusienesAssoclate.vue?vue&type=script&lang=js&"
export * from "./SellBusienesAssoclate.vue?vue&type=script&lang=js&"
import style0 from "./SellBusienesAssoclate.vue?vue&type=style&index=0&id=28a0d878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a0d878",
  null
  
)

export default component.exports